import SideBar from "../template/sidebar/SideBar";

const HomePage = () => {
    return (
        <>
            <SideBar />
        </>
    );
};

export default HomePage;
